import { connect } from 'react-redux';
import { unhideDeviation, blockDeviationAuthor, unblockDeviationAuthor } from '../../Moderation/redux/actions';
import { getHighestPriorityBlockReasonForDeviation } from '../../Moderation/redux/selectors';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { toggleMature } from '../../publicSession/actions';
const mapStateToProps = (state, { deviation  })=>({
        isLoggedIn: getIsLoggedIn(state),
        blockReason: getHighestPriorityBlockReasonForDeviation(state, deviation)
    });
const mapDispatchToProps = {
    unhideDeviation,
    blockDeviant: blockDeviationAuthor,
    unblockDeviant: unblockDeviationAuthor,
    disableMatureFilter: ()=>toggleMature(false)
};
export default connect(mapStateToProps, mapDispatchToProps);
